import React, { useContext, useEffect } from 'react'; //eslint-disable-line
import PropTypes from 'prop-types';

const HeaderColumns = props => {
  return (
    <ul className={props.className ? props.className : ''}>
      {props.headerCol.map((col, index) => {
        if (col === '') return <li className="col-header" key={`${col}${index}`} />;

        return (
          <li key={`${col}`} className="col-header" id={col}>
            {col}
          </li>
        );
      })}
    </ul>
  );
};

HeaderColumns.propTypes = {
  headerCol: PropTypes.array.isRequired
};

export default HeaderColumns;
